import { useSelector } from "react-redux";

import style from "./ViewWorkout.module.css";

import AddScore from "../../Container/AddScore/AddScore";
import ReactLinkify from "react-linkify";

const convertLinkToCorrectFormat = (inputLink) => {
  return inputLink.replace("watch?v=", "embed/");
};

export default function ViewWorkout(props) {
  const userData = useSelector((state) => state.userData);

  const newDescription = (description) => {
    var repsPercentage = {
      percentageValue: "",
      reps: "",
    };
    let i = 0;
    let newDescription = "";
    var str = description;
    do {
      repsPercentage = {
        percentage: "",
        resp: "",
      };

      if (str.indexOf("#") === -1 || str.indexOf("\n") === -1) break;
      let index1 = str.indexOf("#"),
        index2 = str.indexOf("\n");
      var subStr = str.slice(index1, ++index2);
      var repsIndex = subStr.indexOf("Reps");
      var startReps = "#" + (i + 1) + ": ";
      let newPercentage = subStr.slice(repsIndex + 5, subStr.indexOf("%"));
      if (newPercentage === "0" || newPercentage === "100") {
        newPercentage = "";
      }
      repsPercentage = {
        percentage: newPercentage,
        reps: subStr.slice(startReps.length, repsIndex),
      };
      newDescription += `#${i + 1} :  ${repsPercentage.reps}  Reps  ${
        repsPercentage.percentage
      }${repsPercentage.percentage && "%"}\n`;
      str = str.replace(subStr, "");
      i++;
    } while (true);
    return newDescription;
  };

  return (
    <div>
      {props.showAddScore ? (
        <div className="mb-4">
          <AddScore
            workout={props && props.workout}
            modalId={props.modalId}
            trackWorkoutId={props.trackWorkoutId}
            back={props.back}
          />
        </div>
      ) : (
        <div className="pb-4 colorBgWhite bg-white rounded">
          <div className="h6 mb-3">
            {props.workout && props.workout.Name}
          </div>
          {props.workout &&
            props.workout.WorkoutType.toLowerCase() !== "database" &&
            props.workout.videoUrl && (
              <div className={style.videoContainer}>
                <iframe
                  style={{ width: "100%", height: "100%" }}
                  src={convertLinkToCorrectFormat(props.workout.videoUrl)}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            )}
          <ReactLinkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            )}
          >
            {props?.workout?.Description && (
              <div className={`mb-3  mt-3 stringCodeFomrat`}>
                {props.workout &&
                  (props.workout.WorkoutType.toLowerCase() === "deadlift" ? (
                    newDescription(props.workout.Description)
                  ) : (
                    <p>{props.workout.Description}</p>
                  ))}
              </div>
            )}
            {props?.workout?.Notes && (
              <div >
                <div className="h5 border-bottom width-fit-content border-dark mb-0">
                  Notes
                </div>
                <div className="text-break mt-2">{props.workout.Notes}</div>
              </div>
            )}
          </ReactLinkify>
        </div>
      )}
      {userData.Role === "athlete" && (
        <div className="float-right width-fit-content">
          <button
            className={`${
              props.showAddScore && "d-none"
            } basicFatBtnStyle quaternaryColor colorDark mt-4 mb-3`}
            data-dismiss="modal"
          >
            Cancel
          </button>

          <button
            className={`ml-3 ${
              props.showAddScore && "d-none"
            } basicFatBtnStyle primaryBtn mt-4 mb-3`}
            onClick={props.forward}
          >
            <i class="mdi mdi-plus menu-icon colorWhite pl-1 pr-1"></i>
            Add Score
          </button>
        </div>
      )}
    </div>
  );
}
